const __WEBPACK_NAMESPACE_OBJECT__ = flarum.extensions['glowingblue-orell-thalia-common'];